module.exports = __webpack_public_path__ + "img/26.1e760f6c.gif";